// extracted by mini-css-extract-plugin
export default {"base":"UserSearchesPage_base__3IuvE","header":"UserSearchesPage_header__XC2JI","goback":"UserSearchesPage_goback__t2u6T"};